module.exports = __webpack_public_path__ + "img/map_marker_icon.98930f0b.png";